module.exports = "/_next/static/images/RigMirror-2e8b0571ab971a31fbd333970ff6b43c.png";